import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
export class CancelOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/preOrder/cancelPreOrder',
      requesterInfo,
    })
  }

  public async cancelOrder(request: number[]): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
